import { create } from 'zustand';

interface GuideStore {
  vertical: number[];
  horizontal: number[];
  set: (v: number[], h: number[]) => void;
  clear: () => void;
}

export const useGuides = create<GuideStore>(set => ({
  vertical: [], horizontal: [],
  set: (vertical, horizontal) => set({ vertical, horizontal }),
  clear: () => set({ vertical: [], horizontal: [] }),
}));

export function GuideOverlay() {
  const v = useGuides(s => s.vertical);
  const h = useGuides(s => s.horizontal);
  return (
    <>
      {v.map((x, i) => (
        <div key={`v${i}`} style={{ position: 'absolute', left: x, top: -10000, width: 1, height: 20000, background: 'var(--color-accent-2)', pointerEvents: 'none' }} />
      ))}
      {h.map((y, i) => (
        <div key={`h${i}`} style={{ position: 'absolute', top: y, left: -10000, height: 1, width: 20000, background: 'var(--color-accent-2)', pointerEvents: 'none' }} />
      ))}
    </>
  );
}
